import type { Store } from '../types';

type SetState = (
  partial:
    | Partial<Store>
    | ((state: Store) => Partial<Store>),
) => void;

export function withSyncGuard(set: SetState, fn: () => void): void {
  set((state) => ({ sync: { syncInProgress: true } }));
  try {
    fn();
  } finally {
    set((state) => ({ sync: { syncInProgress: false } }));
  }
}

export function isSyncInProgress(state: Store): boolean {
  return state.sync.syncInProgress === true;
}
